import * as TY from 'containers/pages/users/constants';

const userAddReducer = (user, action) => {
	switch (action.type) {
		case TY.F_NAME:
			return { ...user, [TY.F_NAME]: action.payload };
		case TY.L_NAME:
			return { ...user, [TY.L_NAME]: action.payload };
		case TY.COMPANIES:
			return { ...user, [TY.COMPANIES]: action.payload };
		case TY.ACCESS_OPTIONS:
			return { ...user, [TY.ACCESS_OPTIONS]: action.payload };
		case TY.IMAGE:
			return { ...user, [TY.IMAGE]: action.payload };
		case TY.IMAGE_RESET:
			return { ...user, [TY.IMAGE]: action.payload };
		case TY.EMAIL_WORK:
			return { ...user, [TY.EMAIL_WORK]: action.payload };
		case TY.EMAIL_PERSONAL:
			return { ...user, [TY.EMAIL_PERSONAL]: action.payload };
		case TY.EMAIL_OTHER:
			return { ...user, [TY.EMAIL_OTHER]: action.payload };
		case TY.CONTACT_TYPES:
			return { ...user, [TY.CONTACT_TYPES]: action.payload };
		case TY.PHONE_WORK:
			return { ...user, [TY.PHONE_WORK]: action.payload };
		case TY.PHONE_MOBILE:
			return { ...user, [TY.PHONE_MOBILE]: action.payload };
		case TY.PHONE_OTHER:
			return { ...user, [TY.PHONE_OTHER]: action.payload };
		case TY.NOTE:
			return { ...user, [TY.NOTE]: action.payload };
		case TY.NOTE_RESET:
			return { ...user, [TY.NOTE]: '' };
		case TY.ADDRESS_WORK:
			return { ...user, [TY.ADDRESS_WORK]: action.payload };
		case TY.ADDRESS_WORK_UNIT:
			return {
				...user,
				[TY.ADDRESS_WORK]: {
					...user[TY.ADDRESS_WORK],
					[TY.UNIT]: action.payload,
				},
			};
		case TY.ADDRESS_WORK_RESET:
			return { ...user, [TY.ADDRESS_WORK]: action.payload };
		case TY.ADDRESS_HOME:
			return { ...user, [TY.ADDRESS_HOME]: action.payload };
		case TY.ADDRESS_HOME_UNIT:
			return {
				...user,
				[TY.ADDRESS_HOME]: {
					...user[TY.ADDRESS_HOME],
					[TY.UNIT]: action.payload,
				},
			};
		case TY.ADDRESS_HOME_RESET:
			return { ...user, [TY.ADDRESS_HOME]: action.payload };
		case TY.ADDRESS_OTHER:
			return { ...user, [TY.ADDRESS_OTHER]: action.payload };
		case TY.ADDRESS_OTHER_UNIT:
			return {
				...user,
				[TY.ADDRESS_OTHER]: {
					...user[TY.ADDRESS_OTHER],
					[TY.UNIT]: action.payload,
				},
			};
		case TY.ADDRESS_OTHER_RESET:
			return { ...user, [TY.ADDRESS_OTHER]: action.payload };
		case TY.LANGUAGES:
			return { ...user, [TY.LANGUAGES]: action.payload };
		case TY.U_NAME:
			return { ...user, [TY.U_NAME]: action.payload };
		case TY.PWD:
			return { ...user, [TY.PWD]: action.payload };
		case TY.CONFIRM_PWD:
			return { ...user, [TY.CONFIRM_PWD]: action.payload };
		case TY.IS_ENABLED:
			return { ...user, [TY.IS_ENABLED]: action.payload };
		case TY.MST_CUST_ID:
			return { ...user, [TY.MST_CUST_ID]: action.payload };
		case TY.ROLES:
			return { ...user, [TY.ROLES]: action.payload };
		case TY.APPS:
			return { ...user, [TY.APPS]: action.payload };
		case TY.RESET:
			return action.payload;
		case TY.USER_CONVERT:
			return action.payload;
		case TY.POST_LOGIN_APP_ID:
			return { ...user, [TY.POST_LOGIN_APP_ID]: action.payload };
		default:
			return user;
	}
};

export default userAddReducer;
